import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import { useGetSearchRecommendQuery } from 'hooks/queries/search';
import useRecommentEvent from 'hooks/search/useRecommendEvent';
import styled, { css } from 'styled-components';
import useCommonStore from 'store/useCommonStore';

const RecommendBox = () => {
	// store
	const { keyword, selected_recommend } = useCommonStore();

	// query
	const { data } = useGetSearchRecommendQuery(keyword);

	// hooks
	const [selectEnter, selectLeave, selectClick] = useRecommentEvent();

	return (
		<>
			<RecommendBoxWrapper>
				{keyword.trim() !== '' && (
					<RecommendItem
						selected={selected_recommend.idx === 0}
						onMouseEnter={() => selectEnter({ text: keyword, idx: 0 })}
						onMouseLeave={selectLeave}
						onClick={selectClick}
					>
						<CoreSvg>
							<Icon.Search />
						</CoreSvg>
						{keyword}
					</RecommendItem>
				)}
				{keyword.trim() !== '' &&
					data &&
					data?.map((item: string, idx: number) => {
						if (item.trim() !== keyword.trim())
							return (
								<RecommendItem
									key={idx}
									selected={selected_recommend.idx === idx + 1}
									onMouseEnter={() => selectEnter({ text: item, idx: idx + 1 })}
									onMouseLeave={selectLeave}
									onClick={selectClick}
								>
									<CoreSvg>
										<Icon.Search />
									</CoreSvg>
									{item}
								</RecommendItem>
							);
					})}
			</RecommendBoxWrapper>
		</>
	);
};

const RecommendBoxWrapper = styled.ul`
	width: 100%;
	max-width: 640px;
	margin-top: 16px;
`;

const RecommendItem = styled.li<{ selected?: boolean }>`
	width: 100%;
	padding: 16px;
	gap: 8px;

	border-bottom: 1px solid ${({ theme }) => theme.colors.gray.gray15};

	${({ theme }) => theme.common.flexStart};
	${({ theme }) => theme.typo.body.p_bold};

	${({ selected, theme }) =>
		selected
			? css`
					background-color: ${theme.colors.gray.gray10};
			  `
			: css`
            background-color: : ${theme.colors.gray.gray_white};
        `}

	transition: 0.2s background-color;
`;

export default RecommendBox;
